import { preventDuplicate, removeById } from 'utils/global';
import * as actionTypes from './actionTypes';

interface StateProps {
  notifications: [],
}

// eslint-disable-next-line @typescript-eslint/no-explicit-any
function reducer(state:StateProps, action:{ payload: any, type: string }) {
  switch (action.type) {
    case actionTypes.SET_APPLICATION_STATUS:
      return {
        ...state,
        applicationStatus: action.payload,
      };

    case actionTypes.SET_APP_STATE:
      return {
        ...state,
        appState: action.payload,
      };

    case actionTypes.ADD_NOTIFICATION:
      return {
        ...state,
        notifications: [...preventDuplicate(state.notifications, action.payload.label), action.payload],
      };

    case actionTypes.REMOVE_NOTIFICATION:
      return {
        ...state,
        notifications: removeById(state.notifications, action.payload),
      };

    case actionTypes.SET_DEFAULT_PRINTER:
      return {
        ...state,
        defaultPrinter: action.payload,
      };
      
    case actionTypes.SET_SUPPLIERID:
      return {
        ...state,
        organisation: action.payload,
      };

    default:
      return state;
  }
}

export default reducer;
